let sortOptions = [
	<option value='date.desc'>Date (newest first)</option>,
	<option value='date.asc'>Date (oldest first)</option>,
	<option value='team.A-Z'>Seller/Buyer (A-Z)</option>,
	<option value='team.Z-A'>Seller/Buyer (Z-A)</option>,
];

export default sortOptions;
